/**
 * Axios configuration for Dealer's Search Hub API
 * @module SearchHubAPI
 *
 * This a public API in the dealerappcenter organization
 * The purpose is to retrieve information of dealer's banks
 */

import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_SEARCH_HUB_ENDPOINT}/v1`,
});

export default instance;
